import React from 'react'
import { TabbedFormView } from 'react-admin'
import { SimpleMultiCardForm } from './SimpleMultiCardForm'
import { TabbedMultiCardFormProps } from './type'

const MultiplePartTabForm: React.FC<TabbedMultiCardFormProps> = ({
  childrenForms = null,
  formProps = {},
  ...props
}) => {
  return (
    <SimpleMultiCardForm {...formProps}>
      <TabbedFormView toolbar={null} {...props} />
      {childrenForms}
    </SimpleMultiCardForm>
  )
}

export default MultiplePartTabForm
